module.exports = __webpack_public_path__ + "static/media/hall-P11.d1b27701.svg";